import { BACKEND_URL } from '../utils/api';

/**
 * Fetch the current session from the backend (cookie-based)
 * Used after Google OAuth callback redirects back to frontend
 */
export async function fetchSession(setUser) {
    try {
        const res = await fetch(`${BACKEND_URL}/api/auth/google/session`, {
            credentials: 'include'
        });
        if (res.ok) {
            const data = await res.json();
            if (data.user) {
                // Store user in localStorage for consistency with existing auth flow
                localStorage.setItem('user', JSON.stringify(data.user));
                if (data.token) {
                    localStorage.setItem('token', data.token);
                }
                if (setUser) {
                    setUser(data.user);
                }
                return data.user;
            }
        } else {
            console.warn('No active session found');
        }
    } catch (err) {
        console.error('Error fetching session:', err);
    }
    return null;
}

/**
 * Check if user has VIP build access
 * Returns true if user is admin OR (is_active AND plan='vip')
 */
export function hasVIPAccess(user) {
    if (!user) return false;
    return user.is_admin || (user.is_active && user.plan === 'vip');
}

export default { fetchSession, hasVIPAccess };
